<ng-template #showGeneralVideoModal let-modal>
    <div class="modal-body" *ngIf="idVideo && text">
        <div class="text-center">
            <iframe 
                [src]="sanitizedUrl" 
                width="330" 
                height="250" 
                frameborder="0" 
                allow="accelerometer; clipboard-write; encrypted-media" 
                allowfullscreen>
            </iframe>
            <p class="main-text">{{text}}</p>
            <button class="btn btn-primary btn-wmd" (click)="closeModal()">Cerrar</button>
        </div>
    </div>
</ng-template>
